import { blipConversationsInsightsSettingsSource, blipDomainUrl, blipWebsocketHostName, blipWebsocketHostNameTenant, messaginghubWebsocketHostNameTenant, portalDomain, messaginghubWebsocketHostName } from 'app.constants';
import { Contexts, } from 'modules/core/ContextProcessorService';
import { FeatureToggleClientService } from 'feature-toggle-client';
import { CrossAppFeatures } from 'modules/shared/featureToggle/CrossAppFeatures';
import { MessagingHubFeatures } from 'modules/messaginghub/MessagingHubFeatures';
export class BlipConversationsInsightsController {
    static $inject = ['LoadingService', 'TranslateService', 'AccountService2', '$state', 'ContextProcessorService', 'AuthenticationService', 'TenantService'];
    constructor(LoadingService, TranslateService, AccountService2, $state, ContextProcessorService, AuthenticationService, TenantService) {
        'ngInject';
        this.LoadingService = LoadingService;
        this.TranslateService = TranslateService;
        this.AccountService2 = AccountService2;
        this.$state = $state;
        this.ContextProcessorService = ContextProcessorService;
        this.AuthenticationService = AuthenticationService;
        this.TenantService = TenantService;
        this.settingsSource = blipConversationsInsightsSettingsSource;
        this.blipDomainUrl = blipDomainUrl;
        this.blipWebsocketHostName = messaginghubWebsocketHostNameTenant;
        this.blipWebsocketHostNameTenant = messaginghubWebsocketHostNameTenant;
        this.portalDomain = portalDomain;
        this.blipClusterUrl = blipDomainUrl;
        this.checkTenantContext = async (ContextProcessorService) => {
            await ContextProcessorService.waitForInitialization();
            this.isOnTenantContext = this.ContextProcessorService.context === Contexts.Tenants;
        };
        this.checkTenantContext(ContextProcessorService);
        this.user = this.AccountService2.meSync();
        this.language = this.TranslateService.getCurrentLanguage();
        this.webSocketParams = {
            blipDomainUrl,
            blipWebsocketHostName,
            blipWebsocketHostNameTenant,
        };
        this.LoadingService.stopLoading();
        this.tenantId = this.TenantService.getTenantPrefixFromUrl();
    }
    async $onInit() {
        this.account = await this.AccountService2.me();
        this.featureFlags = FeatureToggleClientService.getInstance().getUserInstance().allFlags();
        this.language = this.TranslateService.getCurrentLanguage();
        this.token = this.AuthenticationService.token;
        this.authEmail = this.AuthenticationService.email;
        const useDelegation = await MessagingHubFeatures.GetMessagingHubCommandWithDelegation();
        this.blipWebsocketHostName = useDelegation ? blipWebsocketHostName : messaginghubWebsocketHostName;
        this.blipWebsocketHostNameTenant = useDelegation ? blipWebsocketHostNameTenant : messaginghubWebsocketHostNameTenant;
        this.cluster = this.blipClusterUrl.replace('https://', '').split('.')[0];
        await this.checkFeatures();
    }
    async checkFeatures() {
        this.useFooterWithBlipStatus = await CrossAppFeatures.useFooterWithBlipStatus();
    }
}
BlipConversationsInsightsController.$inject = ['LoadingService', 'TranslateService', 'AccountService2', '$state', 'ContextProcessorService', 'AuthenticationService', 'TenantService'];
